export default __webpack_public_path__ + "static/home-carousel-image-1-efafff73883780f7f257d2fb136da465.jpg";